// IMPORTS
// Modules
import { useEffect } from 'react';
// Assets
import './BackupRestore.scss';


// COMPONENT
export default function BackupRestore (props) {
   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("Backup/Restore"); // set page title
   }, []);

   // Component
   return (
      <div className="backuprestore">
         <p>Backup/Restore Page</p>
      </div>
   );
}